/* iceberg UI */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Avatar, Badge, Box } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React, { Component } from 'react';

import { ReactComponent as Hybrid } from '../../../../images/hybrid.svg';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

class PlatformPicker extends Component {
    constructor(props) {
        super(props);
        this.state = { loaded: false, objectPayload: [] };
    }

    componentDidMount() {
        const visualPayload = {
            Desktop: (
                <IconWithVariant
                    variant="avatar"
                    src="Laptop"
                    size={FontSizes[2]}
                />
            ),
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            Cloud: (
                <IconWithVariant
                    variant="avatar"
                    src="Cloud"
                    size={FontSizes[2]}
                />
            ),
            Hybrid: (
                <Box
                    alt="Hybrid Logo"
                    sx={{
                        color: 'icon.avatar',
                        width: '16px'
                    }}
                >
                    <Hybrid />
                </Box>
            )
        };

        const objectPayload = [];
        Object.keys(visualPayload).forEach((k) => {
            objectPayload[k] = {
                display: k,
                displayVisualOnly: (
                    <Box
                        display="flex"
                        key={`app_source_${k.toLowerCase()}`}
                        mb="4px"
                        style={{ border: 'none' }}
                    >
                        <Badge
                            color="primary"
                            anchorOrigin={{
                                horizontal: 'right',
                                vertical: 'bottom'
                            }}
                            style={{ border: 'none', marginRight: '8px' }}
                            overlap="rectangular"
                            data-trackid="platformPickerBadge"
                        >
                            <Avatar
                                sx={{ backgroundColor: 'background.avatar' }}
                                data-trackid="sourcesrenderIcon"
                            >
                                {visualPayload[k]}
                            </Avatar>
                        </Badge>
                        <span>{k}</span>
                    </Box>
                ),
                id: k
            };
        });

        this.setState({
            loaded: true,
            objectPayload,
            visualOnlyDefault: visualPayload[Hybrid]
        });
    }

    render() {
        const { loaded, objectPayload, visualOnlyDefault } = this.state;
        if (!loaded) {
            return null;
        }

        return (
            <ObjectPicker
                {...this.props}
                disableClearable
                objectPayload={objectPayload}
                objectNameField="display"
                objectNameFieldVisualOnly="displayVisualOnly"
                visualOnlyDefault={visualOnlyDefault}
            />
        );
    }
}

export default PlatformPicker;
